module.exports = __webpack_public_path__ + "fonts/opensans-lightitalic.512b94c1.woff2";